export default [
  {
    path: "/signedCustomer",
    name: "signedCustomer",
    component: () => import("@/views/customerManage/signedCustomer.vue"),
    meta: {
      title: "签约客户",
      keepAlive: true,
    },
  },
  {
    path: "/unsignedCustomer",
    name: "unsignedCustomer",
    component: () => import("@/views/customerManage/unsignedCustomer.vue"),
    meta: {
      title: "解约客户",
      keepAlive: true,
    },
  },
  {
    path: "/PaymentOrder",
    name: "PaymentOrder",
    component: () => import("@/views/customerManage/PaymentOrder.vue"),
    meta: {
      title: "支付订单",
      keepAlive: false,
    },
  },
];
